import { Link } from 'react-router-dom'
import heatPumpImage from '../assets/images/heat_pump_presentation.png'

interface BentoBoxProps {
  backgroundImage?: string;
  title: string;
  items: string[];
}

const BentoBox = ({ backgroundImage, title, items }: BentoBoxProps) => {
  return (
    <div className="relative">
      <div
        className="aspect-square rounded-2xl p-8 text-white relative overflow-hidden"
        style={backgroundImage ? { backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundPosition: 'center' } : undefined}
      >
        {backgroundImage ? (
          <div className="absolute inset-0 bg-black/50" />
        ) : (
          <div className="absolute inset-0 bg-gradient-to-br from-primary-green to-primary-green-dark" />
        )}
        <div className="h-full flex flex-col justify-center relative z-10">
          <h3 className="text-white text-2xl font-bold mb-4">{title}</h3>
          <ul className="space-y-3">
            {items.map((item, index) => (
              <li key={index} className="flex items-center space-x-3">
                <svg className="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <Link
        to="/quote"
        className="absolute -bottom-4 -right-4 bg-white rounded-full shadow-lg px-4 py-3 font-semibold text-primary-green hover:bg-primary-green hover:text-white transition-colors duration-200"
      >
        Get a quote
      </Link>
    </div>
  )
}

const About = () => {
  const whyRenewableItems = [
    'Reduce energy bills by up to 70%',
    'Increase property value',
    'Reduce carbon footprint',
    'Government grants available'
  ]

  return (
    <section id="about" className="section-padding bg-white">
      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="mb-6">
              Leading the Renewable Energy Revolution
            </h2>
            <p className="text-body-lg text-neutral-taupe mb-6">
              At Gaia Powered, we're passionate about helping UK businesses and homeowners transition to clean,
              renewable energy solutions.
              With years of technical experience and many successful complex installations completed,
              we're your trusted partner in creating a sustainable future.
            </p>
            <p className="text-body-lg text-neutral-taupe mb-8">
              Our certified team specialises in solar panel installations, air source heat pumps, and EV charging points.
              We handle everything from initial consultation to ongoing maintenance,
              ensuring you get the most from your renewable energy investment.
            </p>
            <div className="grid grid-cols-2 gap-6 pt-10">
              <div className="text-center">
                <div className="text-5xl font-bold text-primary-green mb-2">70%</div>
                <p className="text-md text-neutral-taupe">of our work comes from Customer Referrals</p>
              </div>
              <div className="text-center">
                <div className="text-5xl font-bold text-primary-green mb-2">5★</div>
                <p className="text-md text-neutral-taupe">Average Rating</p>
              </div>
            </div>
          </div>

          <BentoBox
            backgroundImage={heatPumpImage}
            title="Why Renewable Energy?"
            items={whyRenewableItems}
          />
        </div>
      </div>
    </section>
  )
}

export default About